import UnassignedLeftPanel from './UnassignedLeftPanel'
import AssignedLeftPanel from './AssignedLeftPanel'
import ResolvedLeftPanel from './ResolvedLeftPanel'
import SidePanel from '../SidePanel'
import { SetStateAction, useContext } from 'react'
import ChatContext from '../../../context/ChatContext'

interface IProps {
  type: 'Unassigned' | 'Assigned' | 'Resolved' | 'Chat-Report'
  chatRoomID: any
  isData2: any
  isData3: any
  handleOpenChat: any
  disabledIndexes: any
  updateApplicationIds: (ids: number[]) => void
}

const ChatLeftPanel: React.FC<IProps> = ({
  type,
  chatRoomID,
  isData2,
  isData3,
  handleOpenChat,
  disabledIndexes,
  updateApplicationIds
}) => {
  return (
    <div className='flex-column flex-lg-row-auto w-lg-250px w-xl-350px mx-lg-0 mb-md-2'style={{width:'85%'}}>
      {type === 'Unassigned' && <UnassignedLeftPanel type={type} />}
      {type === 'Assigned' && (
        <AssignedLeftPanel
          type={type}
          chatRoomID={chatRoomID}
          isData2={isData2}
          isData3={isData3}
          handleOpenChat={handleOpenChat}
          disabledIndexes={disabledIndexes}
        />
      )}
      {type === 'Resolved' && (
        <ResolvedLeftPanel
          type={type}
          chatRoomID={chatRoomID}
          updateApplicationIds={updateApplicationIds}
        />
      )}
    </div>
  )
}

export default ChatLeftPanel
